import { render } from "./SpecialtyDataTable.vue?vue&type=template&id=99a90558&scoped=true&lang=pug"
import script from "./SpecialtyDataTable.vue?vue&type=script&lang=js"
export * from "./SpecialtyDataTable.vue?vue&type=script&lang=js"

import "./SpecialtyDataTable.vue?vue&type=style&index=0&id=99a90558&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99a90558"]])

export default __exports__